<template>
  <div id="nav">
    <ul class="nav-menu">
      <li
        v-for="(item,index) in menu"
        v-on:mouseenter="showChildMenu($event,index)"
        v-on:mouseleave="hideChileMenu($event)"
        v-on:click="changPage($event,index)"
        :key="item.name"
        :class="[nav_li]"
      >
        <a
          :href="item.href"
          :component-name="item.href"
          :class="[item.name===currPathName?'active':'']"
        >{{item.name}}</a>
      </li>
    </ul>
    <div class="item">
      <!-- 系统方案 -->
      <div
        v-on:mouseenter="selfShow($event)"
        v-on:mouseleave="hideItem($event)"
        data-index="2"
        class="child"
      >
        <router-link
          class="plans"
          v-for="plan in plans"
          :key="plan.id"
          :to="'/system_scheme/'+plan.id"
        >{{plan.title}}</router-link>
        <!-- <a class="plans" href v-for="plan in plans" :key="plan.name">{{plan.name}}</a> -->
      </div>
      <!-- 产品中心 -->
      <div
        v-on:mouseenter="selfShow($event)"
        v-on:mouseleave="hideItem($event)"
        data-index="3"
        class="child"
      >
        <!-- <div class="list" v-for="specie in products" :key="specie.class">
          <a class="fl" :href="specie.link">{{specie.class}}</a>
          <div class="fr">
            <router-link
              v-for="product in specie.all"
              :key="product.href"
              :to="product.href"
            >{{product.name}}</router-link>
          </div>
        </div>-->

        <div class="list" v-for="item in products" :key="item.id">
          <a href="/product" class="fl">{{item.name}}</a>
          <div class="fr">
            <router-link
              v-for="product in item.products"
              :key="product.id"
              :to="'/product/'+product.id"
            >{{product.product_name}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#nav {
  width: 100%;
  height: 46px;
  /* background: url("../assets/w2.jpg") repeat-x; */
  background-color: rgb(0, 152, 239);
  color: #fff;
}
.nav-menu {
  width: 1100px;
  height: 46px;
  margin: 0 auto;
  text-align: center;
}
.active {
  color: rgb(254, 203, 69) !important;
}
.nav_li a {
  display: inline-block;
  width: 150px;
  height: 46px;
  line-height: 46px;
  color: #fff;
}
.nav-menu li {
  float: left;
  width: 150px;
  height: 46px;
  cursor: pointer;
  color: #fff;
}
.child {
  width: 1100px;
  box-shadow: 0 0 9px 3px rgba(191, 191, 191, 0.5);
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  padding: 8px;
  z-index: 999999;
  background-color: #fff;
}
.plans {
  width: 250px;
  height: 28px;
  margin: 5px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  text-align: left;
  float: left;
}
.plans:hover {
  color: #e45649;
}
.item {
  position: relative;
  width: 1100px;
  margin: 0 auto;
}
.list {
  width: 100%;
  border-bottom: 1px dashed #d9d9d9;
  overflow: hidden;
  padding: 3px 12px;
  box-sizing: border-box;
}
.bg {
  background-color: #ccc !important;
}
.fl {
  float: left;
  width: 195px;
  display: block;
  height: 30px;
  font-size: 16px;
  color: #000;
  line-height: 30px;
}
.fr {
  float: right;
  width: 880px;
}
.fr a {
  /* width: 126px; */
  padding: 0 15px;
  margin-left: 15px;
  display: inline-block;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  color: #666;
}
.fr a:hover {
  color: #e45649;
}
</style>


<script>
export default {
  name: "nav",
  data() {
    return {
      /**导航栏数组 */
      currPathName: "首页",
      menu: [
        { href: "/home", name: "首页" },
        { href: "/about", name: "关于金界" },
        { href: "/system_scheme", name: "系统方案" },
        { href: "/product", name: "产品中心" },
        { href: "/partners", name: "合作伙伴" },
        { href: "/contact", name: "联系我们" }
      ],
      /**方案数据 */
      plans: [
        { name: "校园计算机智慧网络系统", href: "/" },
        { name: "校园动态人脸识别全校通系统", href: "/" },
        { name: "校园电器设备使用智能化控制系统", href: "/" },
        { name: "全校智能电子锁匙系统", href: "/" },
        { name: "课室智能消毒，灭蚊系统", href: "/" },
        { name: "课室空气智能净化系统", href: "/" },
        { name: "学生进校体温自动检测系统", href: "/" },
        { name: "校园特别情况应急对讲系统", href: "/" },
        { name: "校园电器设备故障自动检测系统", href: "/" },
        { name: "校园场室照明自动感光控制系统", href: "/" },
        { name: "课室讲坛装备系统", href: "/" },
        { name: "校园智能广播系统", href: "/" },
        { name: "校园视频自动播放系统", href: "/" },
        { name: "校园智能闭路视频监控系统", href: "/" },
        { name: "校园红外安防报警系统", href: "/" },
        { name: "校园消防设备故障自动检测报警系统", href: "/" },
        { name: "智能洗手间", href: "/" },
        { name: "智慧学生书卓系统", href: "/" }
      ],
      /** 产品种类数据 */
      products: null,
      currPathIndex: 0,
      nav_li: "nav_li"
    };
  },
  /** 方法 */
  methods: {
    /** 显示二级菜单栏 */
    showChildMenu: function(e, item) {
      // if (e.target.nodeName == "LI") {
      //   $(e.target).addClass("bg");
      // }
      $(".child").hide();
      /** 找到相关的对应的index值 */
      $(`[data-index=${item}]`).show();
    },
    hideChileMenu: function(e) {
      // $(".nav_li").removeClass("bg");
      $(".child").hide();
    },
    selfShow: function(e) {
      console.log(e.target);
      $(e.target).show();
    },
    hideItem(e) {
      console.log(e.target);
      $(e.target).hide();
    },
    changPage: function(e, index) {
      this.currPathIndex = index;
      console.log(index);
      // console.log(e.target);
      var page = this.menu[index].href;
      this.$emit("currentViwe", page);
    }
  },
  watch: {
    $route() {
      this.currPathName = this.$route.name;
    }
  },
  mounted() {
    this.currPathName = this.$route.name;
    var _this = this;
    $.ajax({
      url: "/getAllPro.php",
      type: "get",
      data: null,
      success: function(data, textStatus, jqXHR) {
        _this.products = JSON.parse(data);
      }
    });
    /** 请求方案列表 */
    $.ajax({
      url: "/plans.php",
      type: "get",
      data: null,
      headers: {
        "Content-Type": "application/json"
      },
      success: function(data, textStatus, jqXHR) {
        var data = JSON.parse(data);
        _this.plans = data.plans;
      },
      error(jqXHR, status, errormsg) {}
    });
  }
};

/**
 *
 *
 */
</script>





// WEBPACK FOOTER //
// src/components/nav.vue